import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as productSolutionMain from '../reducers';
import * as productSolutionMainSub from '../reducers/get-product-solutions.reducer';

export const getProductSolutionRequest = createSelector(
  productSolutionMain.selectGetProductSolutionState,
  productSolutionMainSub.selectProductSolutions
);

export const getProductSolutionLoaded = createSelector(
  productSolutionMain.selectGetProductSolutionState,
  productSolutionMainSub.selectProductSolutionsLoaded
);

export const getProductSolutionFailure = createSelector(
  productSolutionMain.selectGetProductSolutionState,
  productSolutionMainSub.selectProductSolutionsError
);
